export const ProductPageData: { [key: string]: { [key: string]: string } } = {
  default: {
    sectionsNavItemsPrize: 'Prizes',
    sectionsNavButton: 'Buy Tickets',
    ticketBoxTitle: 'How many tickets?',
    ticketBoxBtn: 'Add tickets to basket',
    ticketBoxBtnOne: 'Add 1 ticket to basket',
    ticketBoxLabel: 'Number of tickets:',
    ticketBoxMaxTickets: 'ticket',
    entryOption: 'ticket',
    productCloseText: 'tickets',
    productEndPrizeDescription: '',
    productEndPrizeInfo: '',
    howWorksFirstStepLabel: '',
    howWorksFirstStepIcon: '',
    howWorksSecondStepLabel: '',
    howWorksThirdStepLabel: '',
    revealBadgeTitle: 'Ticket',
    revealButtonTitle: 'Reveal ticket',
    productDialogText: 'ticket',
    orderUnitLabel: 'Ticket',
    faqLabel: '',
    productErrorMessage: 'Tickets',
    resultWinBadge: 'Winning Ticket'
  },
  'regular-instant-win': {
    sectionsNavItemsPrize: 'Instant Win Prizes',
    sectionsNavButton: 'Buy Tickets',
    ticketBoxTitle: 'How many tickets?',
    ticketBoxBtn: 'Add tickets to basket',
    ticketBoxBtnOne: 'Add 1 ticket to basket',
    ticketBoxLabel: 'Number of tickets:',
    ticketBoxMaxTickets: 'ticket',
    entryOption: 'ticket',
    productCloseText: 'tickets',
    productEndPrizeDescription:
      'Every ticket for this instant win enters you into the',
    productEndPrizeInfo: 'Draw takes place regardless of tickets sold.',
    howWorksFirstStepLabel: 'Buy your tickets',
    howWorksFirstStepIcon: 'hw-ticket.svg',
    howWorksSecondStepLabel: 'Reveal if you’ve won',
    howWorksThirdStepLabel: 'Claim your prize',
    revealBadgeTitle: 'Ticket',
    revealButtonTitle: 'Reveal ticket',
    productDialogText: 'ticket',
    orderUnitLabel: 'Ticket',
    faqLabel: 'instant win',
    productErrorMessage: 'Tickets',
    resultWinBadge: 'Winning Ticket'
  },
  'instant-scratch': {
    sectionsNavItemsPrize: 'Instant Scratch Prizes',
    sectionsNavButton: 'Buy Cards',
    ticketBoxTitle: 'How many scratch cards?',
    ticketBoxBtn: 'Add cards to basket',
    ticketBoxBtnOne: 'Add 1 card to basket',
    ticketBoxLabel: 'Scratch cards:',
    ticketBoxMaxTickets: 'card',
    entryOption: 'card',
    productCloseText: 'scratch cards',
    productEndPrizeDescription:
      'Every card into this Instant Scratch also enters you in the ',
    productEndPrizeInfo: 'Draw takes place regardless of sell out.',
    howWorksFirstStepLabel: 'Get your scratch cards',
    howWorksFirstStepIcon: 'hw-scratch-card.svg',
    howWorksSecondStepLabel: 'Reveal if you’ve won',
    howWorksThirdStepLabel: 'Claim your prize',
    revealBadgeTitle: 'Scratch Card',
    revealButtonTitle: 'Scratch all card',
    productDialogText: 'scratch card',
    orderUnitLabel: 'Scratch Card',
    faqLabel: 'instant scratch',
    productErrorMessage: 'Scratch Cards',
    resultWinBadge: 'Winning Card'
  },
  'instant-flip': {
    sectionsNavItemsPrize: 'Instant Flip Prizes',
    sectionsNavButton: 'Buy Coins',
    ticketBoxTitle: 'How many coins?',
    ticketBoxBtn: 'Add coins to basket',
    ticketBoxBtnOne: 'Add 1 coin to basket',
    ticketBoxLabel: 'Coins:',
    ticketBoxMaxTickets: 'coin',
    entryOption: 'coin',
    productCloseText: 'coins',
    productEndPrizeDescription:
      'Every coin into this Instant Flip also enters you in the ',
    productEndPrizeInfo: 'Draw takes place regardless of sell out.',
    howWorksFirstStepLabel: 'Get your Coins',
    howWorksFirstStepIcon: 'hw-flip-coin.svg',
    howWorksSecondStepLabel: 'Flip to see if you’ve won',
    howWorksThirdStepLabel: 'Collect your prize',
    revealBadgeTitle: 'Coin',
    revealButtonTitle: 'Flip all coin',
    productDialogText: 'flip coin',
    orderUnitLabel: 'Flip coin',
    faqLabel: 'instant flip',
    productErrorMessage: 'Flip Coins',
    resultWinBadge: 'Winning Coin'
  },
  'instant-spin': {
    sectionsNavItemsPrize: 'Instant Spin Prizes',
    sectionsNavButton: 'Buy Spins',
    ticketBoxTitle: 'How many spins?',
    ticketBoxBtn: 'Add spins to basket',
    ticketBoxBtnOne: 'Add 1 spin to basket',
    ticketBoxLabel: 'Spins:',
    ticketBoxMaxTickets: 'spin',
    entryOption: 'spin',
    productCloseText: 'spins',
    productEndPrizeDescription:
      'Every spin into this Instant Spin also enters you in the ',
    productEndPrizeInfo: 'Draw takes place regardless of sell out.',
    howWorksFirstStepLabel: 'Get your Spins',
    howWorksFirstStepIcon: 'hw-spin.svg',
    howWorksSecondStepLabel: 'Reveal if you’ve won',
    howWorksThirdStepLabel: 'Collect your prize',
    revealBadgeTitle: 'spin',
    revealButtonTitle: 'Reveal all spin',
    productDialogText: 'spin',
    orderUnitLabel: 'Spin',
    faqLabel: 'instant spin',
    productErrorMessage: 'Spins',
    resultWinBadge: 'Winning Spin'
  }
};
